/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable spaced-comment */
/* eslint-disable react/self-closing-comp */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-use-before-define */
/* eslint-disable array-callback-return */
/* eslint-disable camelcase */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-array-index-key */
// eslint-disable-next-line prefer-destructuring
import React from "react";
import PropTypes from "prop-types";
import { connect, useDispatch, useSelector } from "react-redux";
import styles from "./UserInfoPanel.module.css";

const UserInfoPanel = () => {
  const auth = useSelector((state) => state.auth);

  let ipAddress=false;
   ipAddress=auth?.ip_address?.startsWith("intranet") 

  let {
    userName,
    personNumber,
    companyCode,
    bookingStatus,
    costCenter,
    userRole,
    workArea,
    persArea,
    sessionId,
  } = auth;

  let userInfo = [];
  if(!ipAddress){
    userInfo = [
      {
        "SAP ID": personNumber,
        "BC No": costCenter,
        LOC: workArea,
      },
    ];
  }else{
    userInfo = [
      {
        Name: userName,
        "SAP ID": personNumber,
        "BC No": costCenter,
        LOC: workArea,
      },
    ];
  }
  return (
    <div className={styles.userInfoPanel}>
      {Object.entries(userInfo[0]).map(([label, value]) => (
        <div key={label}>
          <span>
            <b>{label}</b> {value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default UserInfoPanel;
